import { useEffect, useMemo, useRef, useState } from "react";
import { Card, CardContent, CardHeader, CardTitle } from "../../../components/ui/card";
import { Button } from "../../../components/ui/button";
import { Input } from "../../../components/ui/input";
import { Label } from "../../../components/ui/label";
import PdfViewerContainer from "../../../components/PdfViewerContainer";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../../../components/ui/select";

const SELECT = "SELECT";
const FORM_NAME = "SBI_HOME_LOAN";
const PDF_ENDPOINT = "/FillMyForm/SBI_HOME_LOAN/Print.php";
const TABS = [
  {
    "title": "Personal Details",
    "id": null,
    "fields": [
      {
        "name": "atype",
        "label": "Applicant Type",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "faacno",
        "label": "Account Number",
        "type": "text",
        "required": false,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "faname",
        "label": "Applicant Name",
        "type": "text",
        "required": true,
        "maxLength": 31,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "fadob",
        "label": "Date of Birth",
        "type": "date",
        "required": true,
        "maxLength": null,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "fagender",
        "label": "Gender",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "famstatus",
        "label": "Marital Status",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "famobile",
        "label": "Mobile",
        "type": "text",
        "required": true,
        "maxLength": 10,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "faemail",
        "label": "Email",
        "type": "text",
        "required": true,
        "maxLength": 30,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "faaadhaarno",
        "label": "Aadhaar Number",
        "type": "text",
        "required": true,
        "maxLength": null,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "fapan",
        "label": "PAN Number",
        "type": "text",
        "required": false,
        "maxLength": 10,
        "options": [],
        "numeric": false,
        "uppercase": true
      },
      {
        "name": "fafname",
        "label": "Father's Name",
        "type": "text",
        "required": true,
        "maxLength": 31,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "fasname",
        "label": "Spouse Name",
        "type": "text",
        "required": true,
        "maxLength": 31,
        "options": [],
        "numeric": false,
        "uppercase": false
      }
    ]
  },
  {
    "title": "Permanent Address Details",
    "id": "paddress",
    "fields": [
      {
        "name": "padd1",
        "label": "Address Line 1",
        "type": "text",
        "required": true,
        "maxLength": 41,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "padd2",
        "label": "Address Line 2",
        "type": "text",
        "required": true,
        "maxLength": 41,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "padd3",
        "label": "Address Line 2",
        "type": "text",
        "required": true,
        "maxLength": 41,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "pvillage",
        "label": "Village",
        "type": "text",
        "required": true,
        "maxLength": 16,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "pcity",
        "label": "City",
        "type": "text",
        "required": true,
        "maxLength": 20,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "pdist",
        "label": "District",
        "type": "text",
        "required": true,
        "maxLength": 16,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "pstate",
        "label": "State",
        "type": "text",
        "required": true,
        "maxLength": 20,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "ppin",
        "label": "PIN",
        "type": "text",
        "required": true,
        "maxLength": 15,
        "options": [],
        "numeric": true,
        "uppercase": false
      }
    ]
  },
  {
    "title": "Current Address Details",
    "id": null,
    "fields": [
      {
        "name": "issameadd",
        "label": "Is Current Address same as Permanent Address?",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "YES",
            "YES"
          ],
          [
            "NO",
            "NO"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "cadd1",
        "label": "Address Line 1",
        "type": "text",
        "required": true,
        "maxLength": 41,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "cadd2",
        "label": "Address Line 2",
        "type": "text",
        "required": true,
        "maxLength": 41,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "cadd3",
        "label": "Address Line 2",
        "type": "text",
        "required": true,
        "maxLength": 41,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "cvillage",
        "label": "Village",
        "type": "text",
        "required": true,
        "maxLength": 16,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "ccity",
        "label": "City",
        "type": "text",
        "required": true,
        "maxLength": 20,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "cdist",
        "label": "District",
        "type": "text",
        "required": true,
        "maxLength": 16,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "cstate",
        "label": "State",
        "type": "text",
        "required": true,
        "maxLength": 20,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "cpin",
        "label": "PIN",
        "type": "text",
        "required": true,
        "maxLength": 15,
        "options": [],
        "numeric": true,
        "uppercase": false
      }
    ]
  },
  {
    "title": "Other Details",
    "id": null,
    "fields": [
      {
        "name": "address_type",
        "label": "Address Type",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Permanent",
            "Permanent"
          ],
          [
            "Current",
            "Current"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "residential_type",
        "label": "Residential Type",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Rented",
            "Rented"
          ],
          [
            "Company_Leased",
            "Company Leased"
          ],
          [
            "Owned",
            "Owned"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "ryears",
        "label": "Ryears",
        "type": "text",
        "required": true,
        "maxLength": 2,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "rmonths",
        "label": "Rmonths",
        "type": "text",
        "required": true,
        "maxLength": 2,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "haincome",
        "label": "Household Annual Income",
        "type": "text",
        "required": true,
        "maxLength": 10,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "relation",
        "label": "Relationship with Primary Applicant",
        "type": "select",
        "required": false,
        "maxLength": null,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "ehouses",
        "label": "No. of existing house/ residential plot owned individually or jointly by the customer",
        "type": "text",
        "required": false,
        "maxLength": 2,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "units",
        "label": "No. of units acquired in single residential housing project/co-operative residential complex",
        "type": "text",
        "required": false,
        "maxLength": 2,
        "options": [],
        "numeric": true,
        "uppercase": false
      }
    ]
  },
  {
    "title": "Employment Details",
    "id": null,
    "fields": [
      {
        "name": "icle",
        "label": "Is income considered for loan eligibility?",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Yes",
            "Yes"
          ],
          [
            "No",
            "No"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "occupation",
        "label": "Occupation",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Salaried",
            "Salaried"
          ],
          [
            "Self-Employed1",
            "Self-Employed Professional (Doctor/Engr/Architect/CA)"
          ],
          [
            "Self-Employed2",
            "Self-Employed Professional Other Than Doctor/Engr/Architect/CA"
          ],
          [
            "Business",
            "Business"
          ],
          [
            "Agriculturist",
            "Agriculturist"
          ],
          [
            "Retired",
            "Retired"
          ],
          [
            "Pensioner",
            "Pensioner"
          ],
          [
            "Student",
            "Student"
          ],
          [
            "Home_Maker",
            "Home Maker"
          ],
          [
            "Unemployed",
            "Unemployed"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "otype",
        "label": "Occupation Type",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Central_Govt",
            "Central Govt"
          ],
          [
            "State_Govt",
            "State Govt"
          ],
          [
            "Quasi_Govt",
            "Quasi Govt"
          ],
          [
            "Public_Sector",
            "Public Sector Units"
          ],
          [
            "Defence",
            "Defence"
          ],
          [
            "Corporates",
            "Corporates"
          ],
          [
            "Other",
            "Other Institutions"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "dbranch",
        "label": "Defence Branch",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Army",
            "Indian Army"
          ],
          [
            "Navy",
            "Indian Navy"
          ],
          [
            "Air_Force",
            "Indian Air Force"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "estatus",
        "label": "Employment Status",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Permanent",
            "Permanent"
          ],
          [
            "Contractual",
            "Contractual"
          ],
          [
            "Retainership",
            "Retainership"
          ],
          [
            "Part_Time",
            "Part Time"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "weyear",
        "label": "Weyear",
        "type": "text",
        "required": true,
        "maxLength": 2,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "wemonths",
        "label": "Wemonths",
        "type": "text",
        "required": true,
        "maxLength": 2,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "tpension",
        "label": "Type of Pension",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Old_pension",
            "Old pension scheme"
          ],
          [
            "New_pension",
            "New pension scheme"
          ],
          [
            "Uni􀄤ed_pension",
            "United pension scheme"
          ],
          [
            "EPFO",
            "EPFO"
          ],
          [
            "Others",
            "Others"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "dor",
        "label": "Date Of Retirement",
        "type": "date",
        "required": true,
        "maxLength": null,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "empname",
        "label": "Employer’s Name",
        "type": "text",
        "required": true,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "industry",
        "label": "Industry Name",
        "type": "text",
        "required": true,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "gmincome",
        "label": "Gross Monthly Income",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "nmincome",
        "label": "Net Monthly Income",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "checkoff",
        "label": "Is checkoff available",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Yes",
            "Yes"
          ],
          [
            "No",
            "No"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "biservice",
        "label": "Is there a break in service beyond the period of 3 months in last 2 years",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Yes",
            "Yes"
          ],
          [
            "No",
            "No"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "nsweyears",
        "label": "Nsweyears",
        "type": "text",
        "required": true,
        "maxLength": 2,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "nswemonths",
        "label": "Nswemonths",
        "type": "text",
        "required": true,
        "maxLength": 2,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "npe",
        "label": "Net Profit Earned In Last Two Years",
        "type": "select",
        "required": false,
        "maxLength": null,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "nsgmincome",
        "label": "Gross Monthly Income",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "nsnmincome",
        "label": "Net Monthly Income",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "bname",
        "label": "Business Name",
        "type": "text",
        "required": true,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "nsindustry",
        "label": "Industry Name:",
        "type": "text",
        "required": true,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "badd1",
        "label": "Address Line 1",
        "type": "text",
        "required": true,
        "maxLength": 41,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "badd2",
        "label": "Address Line 2",
        "type": "text",
        "required": true,
        "maxLength": 41,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "badd3",
        "label": "Address Line 2",
        "type": "text",
        "required": true,
        "maxLength": 41,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "bvillage",
        "label": "Village",
        "type": "text",
        "required": true,
        "maxLength": 16,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "bcity",
        "label": "City",
        "type": "text",
        "required": true,
        "maxLength": 20,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "bdist",
        "label": "District",
        "type": "text",
        "required": true,
        "maxLength": 16,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "bstate",
        "label": "State",
        "type": "text",
        "required": true,
        "maxLength": 20,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "bpin",
        "label": "PIN",
        "type": "text",
        "required": true,
        "maxLength": 15,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "blandline",
        "label": "Landline",
        "type": "text",
        "required": true,
        "maxLength": 10,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "bmobile",
        "label": "Mobile",
        "type": "text",
        "required": true,
        "maxLength": 10,
        "options": [],
        "numeric": true,
        "uppercase": false
      }
    ]
  },
  {
    "title": "Salary / Business Account Details",
    "id": null,
    "fields": [
      {
        "name": "sbactype",
        "label": "Account Type",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Saving",
            "Saving"
          ],
          [
            "Current",
            "Current"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "sbbankname",
        "label": "Bank Name",
        "type": "text",
        "required": true,
        "maxLength": 17,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "sbbranch",
        "label": "Branch",
        "type": "text",
        "required": true,
        "maxLength": 15,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "sbacno",
        "label": "Account Number",
        "type": "text",
        "required": false,
        "maxLength": 18,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "sbifsc",
        "label": "IFSC Code",
        "type": "text",
        "required": false,
        "maxLength": 11,
        "options": [],
        "numeric": false,
        "uppercase": false
      }
    ]
  },
  {
    "title": "Loan Details",
    "id": null,
    "fields": [
      {
        "name": "purpose",
        "label": "Purpose",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Plot",
            "Purchase of Plot for construction of a House"
          ],
          [
            "New_House",
            "Purchase of a new House /Flat"
          ],
          [
            "Old_House",
            "Purchase of old House / Flat"
          ],
          [
            "Construction",
            "Construction of a new House/Flat"
          ],
          [
            "Extension",
            "Extension of existing old House/ Flat"
          ],
          [
            "Renovation",
            "Repair or Renovation an existing old House / Flat"
          ],
          [
            "Takeover",
            "Takeover of Home Loans from other Banks / HFCs/FIs"
          ],
          [
            "Combo",
            "Combo Loan"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "lamount",
        "label": "Requested Loan Amount",
        "type": "text",
        "required": false,
        "maxLength": 18,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "pmode",
        "label": "Repayment Mode",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Standing",
            "Standing instruction"
          ],
          [
            "NACH",
            "NACH"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "snactype",
        "label": "Account Type",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Saving",
            "Saving"
          ],
          [
            "Current",
            "Current"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "snbankname",
        "label": "Bank Name",
        "type": "text",
        "required": true,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "snahname",
        "label": "Name of Account Holder",
        "type": "text",
        "required": true,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "snbranch",
        "label": "Branch",
        "type": "text",
        "required": true,
        "maxLength": 20,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "snacno",
        "label": "Account Number",
        "type": "text",
        "required": false,
        "maxLength": 18,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "snifsc",
        "label": "IFSC Code",
        "type": "text",
        "required": false,
        "maxLength": 11,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "sndate",
        "label": "SI / NACH Start date",
        "type": "date",
        "required": true,
        "maxLength": null,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "tenure",
        "label": "Tenure",
        "type": "text",
        "required": false,
        "maxLength": 3,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "moratorium",
        "label": "Moratorium",
        "type": "text",
        "required": false,
        "maxLength": 2,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "eloan",
        "label": "Is there any Existing Loans",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Yes",
            "Yes"
          ],
          [
            "No",
            "No"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "facility",
        "label": "Facility",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Term",
            "Term Loan"
          ],
          [
            "OD",
            "OD (Maxgain)"
          ],
          [
            "Hybrid",
            "Hybrid (TL+OD)"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "capitalized",
        "label": "Whether interest to be capitalized during moratorium period",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Yes",
            "Yes"
          ],
          [
            "No",
            "No"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "IMGC",
        "label": "IMGC Guarantee required:",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Yes",
            "Yes"
          ],
          [
            "No",
            "No"
          ]
        ],
        "numeric": false,
        "uppercase": false
      }
    ]
  },
  {
    "title": "Seller / Builder Details",
    "id": null,
    "fields": [
      {
        "name": "nsbname",
        "label": "Name of Seller / Builer",
        "type": "text",
        "required": true,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "nsbbankname",
        "label": "Bank Name",
        "type": "text",
        "required": true,
        "maxLength": 13,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "nsbbranch",
        "label": "Branch",
        "type": "text",
        "required": true,
        "maxLength": 13,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "nsbifsc",
        "label": "IFSC Code",
        "type": "text",
        "required": false,
        "maxLength": 11,
        "options": [],
        "numeric": false,
        "uppercase": false
      }
    ]
  },
  {
    "title": "Existing Loan - 1",
    "id": "tab_eloan",
    "fields": [
      {
        "name": "elacno1",
        "label": "Account Number",
        "type": "text",
        "required": true,
        "maxLength": 13,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "elbank1",
        "label": "Bank / FI",
        "type": "text",
        "required": true,
        "maxLength": 7,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "elpname1",
        "label": "Product Name",
        "type": "text",
        "required": true,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "elsamount1",
        "label": "Sanctioned Amount",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "elpoutstanding1",
        "label": "Present Outstanding",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "elemi1",
        "label": "EMI",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "elacno2",
        "label": "Account Number",
        "type": "text",
        "required": false,
        "maxLength": 18,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "elbank2",
        "label": "Bank / FI",
        "type": "text",
        "required": false,
        "maxLength": 20,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "elpname2",
        "label": "Product Name",
        "type": "text",
        "required": false,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "elsamount2",
        "label": "Sanctioned Amount",
        "type": "text",
        "required": false,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "elpoutstanding2",
        "label": "Present Outstanding",
        "type": "text",
        "required": false,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "elemi2",
        "label": "EMI",
        "type": "text",
        "required": false,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      }
    ]
  },
  {
    "title": "Property Details",
    "id": null,
    "fields": [
      {
        "name": "perareg",
        "label": "RERA Registration No. (If applicable)",
        "type": "text",
        "required": false,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "projectname",
        "label": "Project Name (If applicable):",
        "type": "text",
        "required": false,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "ptype",
        "label": "Property Type",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Self_constructed",
            "Self-constructed"
          ],
          [
            "Small_Project",
            "Small project not covered under RERA"
          ],
          [
            "PropertyNI",
            "Property not identified"
          ],
          [
            "Builder_Floor",
            "Builder Floor"
          ],
          [
            "Independent_House",
            "Independent House"
          ],
          [
            "Row_House",
            "Row House/ Villas/ Others"
          ],
          [
            "Residential_Apartment",
            "Residential Apartment (RERA APPROVED)"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "pstatus",
        "label": "Property Status",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Ready",
            "Ready for possession"
          ],
          [
            "Under_Construction",
            "Under construction"
          ],
          [
            "Not_Started",
            "Construction not started"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "tribal",
        "label": "Is property in Tribal Area",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Yes",
            "Yes"
          ],
          [
            "No",
            "No"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "pvalue",
        "label": "Property Value",
        "type": "text",
        "required": false,
        "maxLength": 18,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "pheldname",
        "label": "Property held / to be held in the name of",
        "type": "text",
        "required": true,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "stcategory",
        "label": "Sale transaction Category",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Normal",
            "Normal sale"
          ],
          [
            "POA",
            "POA Sale"
          ],
          [
            "Gift",
            "Gift deed"
          ],
          [
            "Third_Party",
            "Sale through third party Guarantor"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "rincome",
        "label": "Net Rental income expected from the proposed house property (Monthly)",
        "type": "text",
        "required": false,
        "maxLength": 18,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "pholding",
        "label": "Property holding status",
        "type": "select",
        "required": true,
        "maxLength": null,
        "options": [
          [
            "SELECT",
            "SELECT"
          ],
          [
            "Lease",
            "Lease"
          ],
          [
            "Free_Hold",
            "Free Hold"
          ]
        ],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "lpyears",
        "label": "Lpyears",
        "type": "text",
        "required": true,
        "maxLength": 2,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "lpmonths",
        "label": "Lpmonths",
        "type": "text",
        "required": true,
        "maxLength": 2,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "barea",
        "label": "Built up area (Sq Ft)",
        "type": "text",
        "required": false,
        "maxLength": 8,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "buildingname",
        "label": "Building Name",
        "type": "text",
        "required": true,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "wingname",
        "label": "Wing Name",
        "type": "text",
        "required": true,
        "maxLength": 40,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "flatno",
        "label": "Flat No",
        "type": "text",
        "required": true,
        "maxLength": 9,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "carea",
        "label": "Carpet Area (Sq ft)",
        "type": "text",
        "required": false,
        "maxLength": 8,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "sbarea",
        "label": "Super Built-up Area (Sq ft)",
        "type": "text",
        "required": false,
        "maxLength": 8,
        "options": [],
        "numeric": false,
        "uppercase": false
      }
    ]
  },
  {
    "title": "Address Details",
    "id": null,
    "fields": [
      {
        "name": "pddd1",
        "label": "Pddd1",
        "type": "text",
        "required": true,
        "maxLength": 41,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "pddd2",
        "label": "Address Line 2",
        "type": "text",
        "required": true,
        "maxLength": 41,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "pddd3",
        "label": "Address Line 2",
        "type": "text",
        "required": true,
        "maxLength": 41,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "pdvillage",
        "label": "Village",
        "type": "text",
        "required": true,
        "maxLength": 16,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "pdcity",
        "label": "City",
        "type": "text",
        "required": true,
        "maxLength": 20,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "pddist",
        "label": "District",
        "type": "text",
        "required": true,
        "maxLength": 16,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "pdstate",
        "label": "State",
        "type": "text",
        "required": true,
        "maxLength": 20,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "pdpin",
        "label": "PIN",
        "type": "text",
        "required": true,
        "maxLength": 15,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "plocation",
        "label": "Location of Plot (Applicable for SBI Realty Loan):",
        "type": "select",
        "required": false,
        "maxLength": null,
        "options": [],
        "numeric": false,
        "uppercase": false
      }
    ]
  },
  {
    "title": "Construction/Purchase Details",
    "id": null,
    "fields": [
      {
        "name": "doa",
        "label": "Date of Agreement to Sale:",
        "type": "date",
        "required": true,
        "maxLength": null,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "aamount",
        "label": "Amount as per Agreement to Sale",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "eccost",
        "label": "Estimated Cost of Construction",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "ecost",
        "label": "Cost of Extension",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "rrcost",
        "label": "Cost of Repair and Renovation",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "icost",
        "label": "Cost of Interior / Finishing",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "spcost",
        "label": "Cost of Solar Photo Voltaic Lighting System",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "gst",
        "label": "GST",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "premium",
        "label": "Premium for insurance of Mortgaged property",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "amenities",
        "label": "Other Amenities",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "mmamount",
        "label": "Amount of margin money",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "mmsource",
        "label": "Source of Margin Money",
        "type": "select",
        "required": false,
        "maxLength": null,
        "options": [],
        "numeric": false,
        "uppercase": false
      }
    ]
  },
  {
    "title": "Collateral Details",
    "id": null,
    "fields": [
      {
        "name": "ctype",
        "label": "Collateral Type",
        "type": "select",
        "required": false,
        "maxLength": null,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "cowner",
        "label": "Collateral Owner",
        "type": "text",
        "required": true,
        "maxLength": 31,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "cdesc",
        "label": "Collateral Description",
        "type": "text",
        "required": true,
        "maxLength": 31,
        "options": [],
        "numeric": false,
        "uppercase": false
      },
      {
        "name": "cvalue",
        "label": "Collateral Value",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "clvalue",
        "label": "Collateral Lien Value",
        "type": "text",
        "required": true,
        "maxLength": 11,
        "options": [],
        "numeric": true,
        "uppercase": false
      },
      {
        "name": "caddress",
        "label": "Collateral Address",
        "type": "text",
        "required": true,
        "maxLength": 31,
        "options": [],
        "numeric": false,
        "uppercase": false
      }
    ]
  },
  {
    "title": "Personal Details",
    "id": null,
    "fields": []
  }
];

const allFields = TABS.flatMap((tab) => tab.fields);
const initialFormData = allFields.reduce((acc, field) => {
  acc[field.name] = field.type === "select" ? (field.options.some(([v]) => v === SELECT) ? SELECT : (field.options[0]?.[0] || "")) : "";
  return acc;
}, {});

function validateField(field, value) {
  const text = String(value ?? "").trim();
  if (field.required) {
    if (field.type === "select" && (!value || value === SELECT)) return `${field.label} is required.`;
    if (!text) return `${field.label} is required.`;
  }
  if (field.name.includes("aadhaar") && text && text.length !== 12) return "Aadhaar number must contain 12 digits.";
  if (field.name.includes("mobile") && text && text.length !== 10) return "Mobile number must contain 10 digits.";
  if (field.name.endsWith("pin") && text && text.length !== 6) return "PIN must contain 6 digits.";
  if (field.name === "faacno" && text && text.length !== 11) return "Account number must contain 11 digits.";
  if (field.name === "fapan" && text && !/^[A-Z]{5}[0-9]{4}[A-Z]$/.test(text)) return "Enter a valid PAN number.";
  if (field.name === "faemail" && text && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(text)) return "Enter a valid email address.";
  return "";
}

function formatDate(value) {
  if (!value) return "-";
  const [year, month, day] = value.split("-");
  return year && month && day ? `${day}/${month}/${year}` : value;
}

export default function HomeLoan() {
  const [currentTab, setCurrentTab] = useState(0);
  const [maxAllowedTab, setMaxAllowedTab] = useState(0);
  const [formData, setFormData] = useState(initialFormData);
  const [errors, setErrors] = useState({});
  const [pdfUrl, setPdfUrl] = useState("");
  const [showPdf, setShowPdf] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(false);
  const [pdfError, setPdfError] = useState("");
  const nextButtonRef = useRef(null);

  const isPreview = currentTab === TABS.length - 1;
  const isSalaried = formData.occupation === "Salaried";
  const showDefenceBranch = formData.otype === "Defence";
  const showRelation = formData.atype && formData.atype !== SELECT && formData.atype !== "Applicant";
  const showExistingLoan = formData.eloan !== "No";

  const visibleTabs = useMemo(() => TABS.map((tab, index) => ({ ...tab, originalIndex: index })).filter((tab) => !(tab.id === "tab_eloan" && !showExistingLoan)), [showExistingLoan]);
  const activeTab = TABS[currentTab];

  const visibleFields = useMemo(() => {
    if (!activeTab) return [];
    return activeTab.fields.filter((field) => {
      if (field.name === "relation") return showRelation;
      const salaried = ["otype","dbranch","estatus","weyear","wemonths","tpension","dor","empname","industry","gmincome","nmincome","checkoff","biservice"];
      const nonSalaried = ["nsweyears","nswemonths","npe","nsgmincome","nsnmincome","bname","nsindustry","badd1","badd2","badd3","bvillage","bcity","bdist","bstate","bpin","blandline","bmobile"];
      if (salaried.includes(field.name)) {
        if (!isSalaried) return false;
        if (field.name === "dbranch") return showDefenceBranch;
      }
      if (nonSalaried.includes(field.name) && isSalaried) return false;
      return true;
    });
  }, [activeTab, isSalaried, showDefenceBranch, showRelation]);

  const firstFieldName = visibleFields[0]?.name;
  const lastFieldName = visibleFields[visibleFields.length - 1]?.name;

  useEffect(() => {
    if (!firstFieldName) return undefined;
    const frame = window.requestAnimationFrame(() => document.getElementById(firstFieldName)?.focus());
    return () => window.cancelAnimationFrame(frame);
  }, [currentTab, firstFieldName]);

  useEffect(() => () => { if (pdfUrl?.startsWith("blob:")) URL.revokeObjectURL(pdfUrl); }, [pdfUrl]);

  const updateField = (field, rawValue) => {
    let value = rawValue;
    if (field.numeric) value = value.replace(/\D/g, "");
    if (field.uppercase) value = value.toUpperCase();

    setFormData((previous) => {
      const next = { ...previous, [field.name]: value };
      if (field.name === "issameadd") {
        const names = ["add1","add2","add3","village","city","dist","state","pin"];
        names.forEach((suffix) => { next[`c${suffix}`] = value === "YES" ? previous[`p${suffix}`] || "" : ""; });
      }
      if (field.name === "occupation") {
        const clear = value === "Salaried" ? ["nsweyears","nswemonths","npe","nsgmincome","nsnmincome","bname","nsindustry","badd1","badd2","badd3","bvillage","bcity","bdist","bstate","bpin","blandline","bmobile"] : ["otype","dbranch","estatus","weyear","wemonths","tpension","dor","empname","industry","gmincome","nmincome","checkoff","biservice"];
        clear.forEach((name) => { next[name] = ""; });
      }
      return next;
    });
    setErrors((previous) => ({ ...previous, [field.name]: "" }));
  };

  const validateCurrentTab = () => {
    const nextErrors = {};
    visibleFields.forEach((field) => {
      const message = validateField(field, formData[field.name]);
      if (message) nextErrors[field.name] = message;
    });
    setErrors((previous) => ({ ...previous, ...nextErrors }));
    return Object.keys(nextErrors).length === 0;
  };

  const findNextTab = (direction) => {
    let next = currentTab + direction;
    while (next >= 0 && next < TABS.length) {
      if (!(TABS[next].id === "tab_eloan" && !showExistingLoan)) return next;
      next += direction;
    }
    return currentTab;
  };

  const goNext = (event) => {
    event?.preventDefault();
    if (!validateCurrentTab()) return;
    const next = findNextTab(1);
    setCurrentTab(next);
    setMaxAllowedTab((previous) => Math.max(previous, next));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const goPrevious = () => {
    setCurrentTab(findNextTab(-1));
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const handleLastFieldKeyDown = (event, name) => {
    if (name === lastFieldName && event.key === "Tab" && !event.shiftKey) {
      event.preventDefault();
      nextButtonRef.current?.focus();
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setPdfLoading(true);
    setPdfError("");
    try {
      const body = new FormData();
      Object.entries(formData).forEach(([name, value]) => body.append(name, value === SELECT ? "" : String(value ?? "")));
      const response = await fetch(PDF_ENDPOINT, { method: "POST", body, credentials: "include", headers: { Accept: "application/pdf" } });
      if (!response.ok) throw new Error((await response.text()) || `PDF generation failed (${response.status}).`);
      const contentType = response.headers.get("content-type") || "";
      if (!contentType.includes("application/pdf")) throw new Error((await response.text()) || "Print.php did not return a PDF file.");
      const blob = await response.blob();
      const objectUrl = URL.createObjectURL(blob);
      setPdfUrl((previous) => { if (previous?.startsWith("blob:")) URL.revokeObjectURL(previous); return objectUrl; });
      setShowPdf(true);
    } catch (error) {
      console.error("SBI Home Loan PDF error:", error);
      setPdfError(error.message || "Unable to generate PDF preview.");
    } finally { setPdfLoading(false); }
  };

  const renderField = (field) => {
    const error = errors[field.name];
    return <div key={field.name} className="space-y-2">
      <Label htmlFor={field.name}>{field.label}{field.required && <span className="text-red-500"> *</span>}</Label>
      {field.type === "select" ? <Select value={formData[field.name]} onValueChange={(value) => updateField(field, value)}>
        <SelectTrigger id={field.name} className={error ? "border-red-500" : ""} onKeyDown={(event) => handleLastFieldKeyDown(event, field.name)}><SelectValue placeholder={`Select ${field.label}`} /></SelectTrigger>
        <SelectContent>{field.options.map(([value, label]) => <SelectItem key={value} value={value}>{label}</SelectItem>)}</SelectContent>
      </Select> : <Input id={field.name} name={field.name} type={field.type || "text"} value={formData[field.name]} maxLength={field.maxLength || undefined} placeholder={field.label} className={error ? "border-red-500" : ""} onChange={(event) => updateField(field, event.target.value)} onKeyDown={(event) => handleLastFieldKeyDown(event, field.name)} />}
      {error && <p className="text-sm text-red-500">{error}</p>}
    </div>;
  };

  if (showPdf && pdfUrl) return <PdfViewerContainer pdfUrl={pdfUrl} title="SBI Home Loan Application" onBack={() => setShowPdf(false)} />;

  return <div className="min-h-screen bg-background p-6"><div className="mx-auto max-w-7xl">
    <Card className="mb-6"><CardHeader><CardTitle className="text-3xl">🏠 SBI Home Loan Application</CardTitle><p className="text-muted-foreground">Complete all applicable sections carefully.</p></CardHeader></Card>
    <div className="mb-8 grid grid-cols-2 gap-3 md:grid-cols-4 lg:grid-cols-7">{visibleTabs.map((tab) => <Button key={tab.originalIndex} type="button" variant={currentTab === tab.originalIndex ? "default" : "outline"} disabled={tab.originalIndex > maxAllowedTab} onClick={() => setCurrentTab(tab.originalIndex)}>{tab.originalIndex + 1}. {tab.title}</Button>)}</div>

    {!isPreview ? <Card><CardHeader><CardTitle>{activeTab.title}</CardTitle></CardHeader><CardContent><div className="grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">{visibleFields.map(renderField)}</div></CardContent></Card> : <Card><CardHeader><CardTitle>📋 Preview</CardTitle></CardHeader><CardContent className="space-y-8">{TABS.slice(0,-1).filter((tab) => !(tab.id === "tab_eloan" && !showExistingLoan)).map((tab) => <section key={tab.title}><h3 className="mb-3 text-lg font-semibold">{tab.title}</h3><div className="overflow-hidden rounded-lg border">{tab.fields.filter((field) => visibleFields || true).map((field) => <div key={field.name} className="grid grid-cols-2 border-b p-3 last:border-b-0"><span className="font-medium">{field.label}</span><span className="break-words">{field.type === "date" ? formatDate(formData[field.name]) : field.type === "select" ? (field.options.find(([value]) => value === formData[field.name])?.[1] || formData[field.name] || "-") : formData[field.name] || "-"}</span></div>)}</div></section>)}</CardContent></Card>}

    {pdfError && <p className="mt-4 rounded-lg border border-red-300 bg-red-50 p-3 text-red-700">{pdfError}</p>}
    <div className="mt-6 flex items-center justify-between"><Button type="button" variant="outline" onClick={goPrevious} disabled={currentTab === 0}>← Previous</Button>{isPreview ? <Button type="button" ref={nextButtonRef} onClick={handleSubmit} disabled={pdfLoading}>{pdfLoading ? "Generating PDF..." : "Submit & Preview PDF"}</Button> : <Button type="button" ref={nextButtonRef} onClick={goNext}>{findNextTab(1) === TABS.length - 1 ? "Preview" : "Next →"}</Button>}</div>
  </div></div>;
}
